//***************
// IndexedDB/index.ts
//***************

import { IDBDatabaseEx } from './IDBDatabase';
// import CodeValuesDB, { codeValueStore, codeValuesUpdateStore } from './CodeValues';
import CodeValuesDB, { CodeValueStore } from './CodeValuesDB';
import ActivityLogDB, { activityLogStore } from './ActivityLogDB';

const dbName = 'NebraskaDatabase';

var db: IDBDatabaseEx;

export function wrapCursor(request: IDBRequest): Promise<any> {
	return new Promise((resolve, reject) => {
		request.onsuccess = (ev: any) => resolve(ev.target.result);
		request.onerror = (err) => reject(err);
	});
}

export function wrapRequest<T>(request: IDBRequest): Promise<T> {
	return new Promise((resolve, reject) => {
		request.onsuccess = () => resolve(request.result);
		request.onerror = (err) => reject(err);
	});
}

/* NOTE: Never edit an existing upgrade. Always release a new one so that the version increments for the users.
         Any change to the IndexedDB should be made using a new upgrade.
         I would suggest putting larger updates in separate files for cleanliness.
   EXAMPLE: import codeValueUpdate from "./IndexedDBUpdates/codeValueUpdate";
            [db => !codeValueUpdate.hasUpdate(db), db => codeValueUpdate.update(db)] */
const upgrades: [(db: IDBDatabaseEx) => boolean, (db: IDBDatabaseEx) => void][] = [
	[ (db) => !db.objectStoreNames.contains(activityLogStore), (db) => ActivityLogDB.createStore(db) ],
	[ (db) => !db.objectStoreNames.contains(CodeValueStore), (db) => CodeValuesDB.createStore(db) ]
];

export default class IndexedDB {
	private static initializedDb: Promise<any>;

	static initDb = () => {
		if (IndexedDB.initializedDb) {
			return IndexedDB.initializedDb;
		}

		IndexedDB.initializedDb = new Promise((resolve, reject) => {
			var request = indexedDB.open(dbName, upgrades.length);

			request.onsuccess = (ev) => {
				db = request.result;
				db.onerror = (e: any) => {
					console.log(e);
				};

				IndexedDB.initSubDBs(db);
				resolve(db);
			};

			request.onerror = (ev) => {
				console.log('Got an error!');
				IndexedDB.initializedDb = null;
				reject(ev);
			};

			request.onupgradeneeded = (ev) => {
				console.log('OnUpgradeNeeded called!');
				db = request.result;
				upgrades.forEach((upgrade) => {
					if (upgrade[0](db)) {
						upgrade[1](db);
					}
				});
			};

			request.onblocked = () => {
				console.log("Your database version can't be upgraded because the app is open somewhere else.");
			};
		});

		return IndexedDB.initializedDb;
	};

	/**
   * @description initialize the db objects of te sub stores
   * @param db - db object
   */
	static initSubDBs = (db: any) => {
		CodeValuesDB.initializeDB(db);
		ActivityLogDB.initializeDB(db);
	};

	/**
   * @description get value from provided store,index
   * @param {string} storeName - store to pull from
   * @param {string} indexName - index to use
   * @param {any[]} indexValues - index values to use
   * @returns database transaction
   */
	static getValueFromIndex = (storeName: string, indexName: string, indexValues: any[]) => {
		if (!db) return;

		return db.transaction(storeName, 'readonly').objectStore(storeName).index(indexName).get(indexValues);
	};
}
